import * as actionTypes from '../../actions/actionTypes';

export const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SUBSCRIPTION:
      return {
        ...state,
        [`${action.subType}${action.id}`]: action.subscription
      };
    case actionTypes.CLEAR_SUBSCRIPTIONS:
      return initialState;
    default:
      return state;
  }
};

export default reducer;